module.exports = __webpack_public_path__ + "img/engine.e228e6f5.jpg";